// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"65afbef2","929":"58cbaead"}[chunkId] + ".chunk.js";
};